module.exports = __webpack_public_path__ + "img/horizontal_4_5_7042.c193678c.png";